/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm.js';
import router from '@/router';
import App from '@/App.vue';
import AuthService from '@/services/AuthService';
import store from '@/store';
import Manutencao from '@/views/Manutencao.vue';
import 'intersection-observer';
import PsscPublic from '@/routes/PsscPublic';
import TrilhaPssc from '@/views/pssc/Trilha.vue';

// Import dos CSS que são globais
import '@/styles/main.scss';
import '@mdi/font/css/materialdesignicons.min.css';
import 'lodash/lodash.min.js';

// Import das dependências que são globais
import 'bootstrap/dist/js/bootstrap.min.js';
// import VueCarousel from 'vue-carousel';
import vueNumeralFilterInstaller from 'vue-numeral-filter';

import '@/assets/flow-icons/style.css';
import '@/assets/vega-icons/style.css';
import '@/assets/lyra-icons/style.css';
import '@/assets/bandeiras/bandeiras.css';

import ElementConfig from './element-config';
import locale from 'elementui-lts/lib/locale';
import langPt from 'elementui-lts/lib/locale/lang/pt-br';
import langEn from 'elementui-lts/lib/locale/lang/en';
import langEs from 'elementui-lts/lib/locale/lang/es';

import keycloak from 'keycloak-js';

import VueMask from 'v-mask';
import VueTheMask from 'vue-the-mask';
import Vuelidate from 'vuelidate';
import VueIframe from 'vue-iframes';
import VueGtag from 'vue-gtag';
import Hotjar from 'vue-hotjar';

import VueI18n from 'vue-i18n';

import JsonCSV from 'vue-json-csv';

import { handleImpersonationFlow } from './utils/impersonate';

import keycloakUtil from './utils/keycloak';
import {updateConfig} from './utils/mapa/mapa.config';

import VueObserveVisibility from 'vue-observe-visibility';

import { UnleashPlugin } from './utils/featureFlags/unleashPlugin';
import { ModuleService } from '@/modules';

const InfiniteLoading = () =>
    import('vue-infinite-loading/dist/vue-infinite-loading.js');

window.Vue = Vue;

Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();
Vue.use(VueI18n);
Vue.use(VueObserveVisibility);

const i18n = new VueI18n({
    locale: 'pt-BR',
    fallbackLocale: 'pt-BR',
    messages: {
        'pt-BR': require('./locales/pt-br.json'),
        en: require('./locales/en.json'),
        es: require('./locales/es.json')
    }
});

function setLocaleElementUI(i18nLocale) {
    switch (i18nLocale) {
        case 'en':
            locale.use(langEn);
            break;
        case 'pt-BR':
            locale.use(langPt);
            break;
        case 'es':
            locale.use(langEs);
            break;
        default:
            locale.use(langPt);
    }
}

if (window.location.href.includes('pssc/trilha')) {
    const userLocale = 'pt-BR';
    i18n.locale = userLocale;

    setLocaleElementUI(i18n.locale);
    ElementConfig.config();

    new Vue({
        i18n,
        PsscPublic,
        render: h => h(TrilhaPssc)
    }).$mount('#app');
} else {
    Vue.use(VueMask);
    Vue.use(VueTheMask);
    Vue.use(Vuelidate);
    Vue.use(InfiniteLoading);
// Vue.use(VueCarousel);
    Vue.use(vueNumeralFilterInstaller, {locale: 'pt-br'});
    Vue.component('downloadCsv', JsonCSV);
    Vue.use(VueIframe);

    const isProductionEnv = process.env.NODE_ENV === 'production';

    Vue.use(
        VueGtag,
        {
            pageTrackerScreenviewEnabled: false,
            pageTrackerUseFullPath: isProductionEnv,
            config: {
                id: 'G-8EZ1S1K20P',
                params: {
                    send_page_view: isProductionEnv
                }
            }
        }
    );

    Vue.use(Hotjar, {
        id: '3819022',
        isProduction: isProductionEnv
    });

    Vue.use(UnleashPlugin);

    Vue.prototype._i18n = i18n;

    handleImpersonationFlow().finally(() => {

        let initOptions = {
            url: process.env.VUE_APP_KEYCLOAK_AUTH_URL,
            realm: process.env.VUE_APP_KEYCLOAK_REALM,
            clientId: keycloakUtil.getClientId(),
            onLoad: 'login-required'
        };

        let kc = keycloak(initOptions);
        kc.init({onLoad: initOptions.onLoad})
            .then(async (auth) => {
                if (auth) {
                    sessionStorage.setItem('jwtToken', kc.token);
                    sessionStorage.setItem('refreshToken', kc.refreshToken);
                    sessionStorage.setItem('idToken', kc.idToken);
                    updateConfig();
                    let {data} = await AuthService.buscarDadosUsuarioLogado();

                    store.commit('SET_USUARIO_LOGADO', data);

                    const userLocale = data.locale || 'pt-BR';
                    i18n.locale = userLocale;

                    setLocaleElementUI(i18n.locale);
                    ElementConfig.config();

                    ModuleService.install(router, i18n);

                    const esconderMenu = localStorage.getItem('hidden_menu') === 'true';

                    new Vue({
                        i18n,
                        router,
                        store,
                        render: h => h(App, {
                            props: { keycloak: kc, esconderMenus: esconderMenu }
                        })
                    }).$mount('#app');
                }
            })
            .catch(err => {
                sessionStorage.setItem('jwtToken', null);
                new Vue({
                    i18n,
                    render: h => h(Manutencao)
                }).$mount('#app');
                throw err;
            });
        Vue.prototype.keycloak = kc;

        kc.onTokenExpired = () => {
            kc.updateToken(30)
                .then(() => {
                    sessionStorage.setItem('jwtToken', kc.token);
                    updateConfig();
                })
                .catch(erro => {
                    localStorage.removeItem('exportaPDF');
                });
        };

        Vue.prototype.$setLocaleElementUI = setLocaleElementUI;
    });
}

export default i18n;
